// extracted by mini-css-extract-plugin
export default {"loading":"List_loading__ngDGJ","empty":"List_empty__Hd1PN","list":"List_list__TVXTi"};